import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function NationalIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validNationalId = /^(2|3)[0-9][0-9]([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])(01|02|03|04|05|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)[0-9]{5}$/.test(control.value);
      return !validNationalId ? {nationalIdPattern: false} : null;
    };
}